<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-select
          v-model="quick_id"
          class="handle-select mr10"
          @change="selectHandle"
        >
          <el-option
            v-for="(child, index) in quicks"
            :key="index"
            :label="child.name"
            :value="child.id"
          ></el-option>
        </el-select>
        <el-button
            type="primary"
            icon="el-icon-lx-add"
            class="handle-add"
            @click="handleEdit(null, true)"
        >新增</el-button>
      </div>
      <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column label="序号" align="center">
          <template slot-scope="scope">
            <span>{{scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型" align="center">
          <template slot-scope="scope">{{getQuickName(scope.row.type)}}</template>
        </el-table-column>
        <el-table-column prop="content" label="内容" align="center"></el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
                type="text"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
            >删除</el-button>
            <el-button
                type="text"
                icon="el-icon-edit"
                @click="handleEdit(scope.row, false)"
            >修改</el-button>
            </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="totalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="page_size"
          :page-count="totalPages"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 编辑弹出框 -->
    <el-dialog :visible.sync="editVisible" width="50%" :close-on-click-modal="false">
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="类型：" prop="type" v-if="is_add">
          <el-select v-model="form.type" class="handle-select">
            <el-option
              v-for="(child, index) in quicks"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型：" v-else>
          <span class="fc">{{getQuickName(form.type)}}</span>
        </el-form-item>
        <el-form-item label="内容：" prop="content">
          <el-input v-model="form.content" @input="onInput()"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit('ruleForm')">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { _ } from "vue-underscore";
import http from "../../../api/iapetusApiConfig";
export default {
  name: "Doctorlist",
  data() {
    return {
      quicks: [
        {"name": "常用", "id": 1},
        {"name": "诊中", "id": 2},
        {"name": "诊后", "id": 3},
        {"name": "用药", "id": 4},
        {"name": "其他", "id": 5}
      ],
      quick_id: 1,
      tableData: [],
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 0,
      loading: false,
      editVisible: false,
      is_add: false,
      form: {},
      rules: {
        content: [
          { required: true, message: "请填写内容", trigger: "blur" },
        ],
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getQuickName(id) {
      var item = _.filter(this.quicks, function (selector) {
        return selector.id == id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    getData() {
      let that = this;
      that.loading = true;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
      };
      params["type"] = that.quick_id;
      http.get("/admin/quick_replies", { params: params }).then(function (res) {
        that.page_index = (that.currentPage - 1) * that.page_size;
        that.tableData = res.data.data;
        that.currentPage = res.data.data.page;
        that.totalPages = res.data.data.total_pages;
        that.loading = false;
      });
    },
    selectHandle() {
      this.currentPage = 1;
      this.getData();
    },
    // 删除操作
    handleDelete(row) {
      let that = this;
      // 二次确认删除
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("/admin/quick_replies/" + row.id).then(function (res) {
            if (res.data.status_code == 200) {
              that.$message.success("删除成功");
              that.getData();
            }
          });
        })
        .catch(() => {});
    },
    onInput() {
      this.$forceUpdate();
    },
    // 编辑操作
    handleEdit(row, add) {
      this.is_add = add;
      if(add){
        this.form = {
          type: this.quick_id,
          content: ''
        }
      }else{
        this.form = {
          id: row.id,
          type: row.type,
          content: row.content
        }
      }
      this.editVisible = true;
    },
    // 保存编辑
    saveEdit(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            type: that.form.type,
            content: that.form.content,
          };
          if(that.is_add){
            http.post("/admin/quick_replies", params)
            .then(function (res) {
              if (res.data.status_code == 200) {
                that.getData();
              }
            });
          }else{
            http.put("/admin/quick_replies/" + that.form.id, params)
            .then(function (res) {
              if (res.data.status_code == 200) {
                that.getData();
              }
            });
          }
          that.editVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 分页导航
    handlePageChange(val) {
      this.currentPage = val;
      this.getData();
    }
  }
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}
.self-dialog-footer {
  display: block;
  text-align: center;
}
.avatar {
  height: 178px;
  line-height: 178px;
  display: block;
  max-width: 100%;
  text-align: center;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>
